import { createSelector } from 'reselect'

const dataDeletionSelector = ({ organizationSettings }) => organizationSettings.dataDeletion

export const isInviteeDeletionStatusSuccessSelector = createSelector(
  dataDeletionSelector,
  ({ inviteeDeletionStatus }) => inviteeDeletionStatus === 'success'
)

export const isEventsDeletionStatusSuccessSelector = createSelector(
  dataDeletionSelector,
  ({ eventsDeletionStatus }) => eventsDeletionStatus === 'success'
)

export const inviteeInvalidEmailsSelector = createSelector(
  dataDeletionSelector,
  (errors) => Object.keys(errors)
)

export const deletionRequestsSelector = createSelector(
  dataDeletionSelector,
  ({ isDeletionRequestsLoading, deletionRequests }) => ({ isLoading: isDeletionRequestsLoading, deletionRequests })
)

export const orderBySelector = createSelector(
  dataDeletionSelector,
  ({ orderBy }) => orderBy
)

export const sortSelector = createSelector(
  dataDeletionSelector,
  ({ sort }) => sort
)

export const pageSelector = createSelector(
  dataDeletionSelector,
  ({ page }) => page
)
